function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { Button, ConfirmationModal, Typography } from 'seagull';
import { NewTab } from 'seagull/icons';
import { CopyToClipboard } from "../../../components/CopyToClipboard/CopyToClipboard";
import { openInNewTabProps } from "../../../constants";
import { useEventReporter, useOverlayContext, useStoreActions } from "../../../contexts";
import { useOnMount } from "../../../hooks/useOnMount";
import styles from "../CopyAPIKeyModal/CopyAPIKeyModal.module.scss";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import ZapierLogo from "./ZapierLogo";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ZapierIntegrateModal(_ref) {
  let {
    dismissModal,
    getApiKey,
    onCopyApiKey
  } = _ref;
  const [apiKey, setApiKey] = useState('');
  const [helperText, setHelperText] = useState('');
  useOnMount(() => {
    getApiKey().then(setApiKey).catch(() => setHelperText('API key not found. Please try again later.'));
  });
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Integrate with Zapier",
    width: "760px",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.modalContainer,
      children: [/*#__PURE__*/_jsx(Typography, {
        children: "To integrate with Zapier, follow the next steps: "
      }), /*#__PURE__*/_jsx(Typography, {
        children: "1. Copy the API key below"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.copyApiKeyContainer,
        children: /*#__PURE__*/_jsx(CopyToClipboard, {
          "data-testid": "zapier-api-key",
          value: apiKey,
          helperText: helperText,
          error: !!helperText,
          onClick: onCopyApiKey
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.stepsContainer,
        children: /*#__PURE__*/_jsx(Typography, {
          children: "2. Login to your Zapier account, create a zap with Anchor and paste the API key"
        })
      }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        skin: "primaryOutline",
        "data-testid": "go-to-zapier",
        as: "a",
        suffixIcon: /*#__PURE__*/_jsx(NewTab, {}),
        href: "https://zapier.com/app/connections"
      }, openInNewTabProps), {}, {
        className: styles.goToContainer,
        children: "Go to Zapier"
      }))]
    }),
    primaryButtonLabel: "Close",
    onPrimaryButtonClick: dismissModal,
    onCloseButtonClick: dismissModal,
    "data-testid": "integrate-with-zapier-modal"
  });
}
export default function ZapierCard() {
  const {
    api
  } = useStoreActions();
  const {
    reportToAppcues,
    reportToGtm,
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const overlayContext = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const openIntegrateModal = () => {
    logBI(12050);
    reportToAppcues('button-click', "zapier-vendor-clicked-connect");
    reportToGtm('button-click', "zapier-vendor-clicked-connect");
    reportToHeap('integrations', 'click', "zapier-connect");
    reportToHubspot("vendor_clicked_connect_to_zapier");
    overlayContext.showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(ZapierIntegrateModal, {
          dismissModal: dismissModal,
          getApiKey: () => api.zapier.getApiKey(),
          onCopyApiKey: () => {
            logBI(12051);
            reportToAppcues('button-click', "zapier-vendor-copied-api-key-to-clipboard");
            reportToGtm('button-click', "zapier-vendor-copied-api-key-to-clipboard");
            reportToHeap('integrations', 'click', "zapier-copy-api-key");
            reportToHubspot('vendor_copied_api_key_to_clipboard');
          }
        });
      }
    });
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "zapier-card",
    icon: /*#__PURE__*/_jsx(ZapierLogo, {}),
    title: "Zapier",
    subTitle: "Integrate Anchor with hundreds of other apps to automate your work",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: openIntegrateModal,
      "data-testid": "zapier-card-connect",
      children: "Connect"
    })
  });
}